/**
 * Brandner Phone Verification
 *
 * - Country prefix dropdown synced with billing_country
 * - Injects "Code anfordern" button next to phone input
 * - OTP popup with 6 digit inputs (auto-advance, paste support)
 * - 60s cooldown timer for resend
 * - Polls the delivery status after sending (reject/slow/delivered shown without another click)
 * - Monitors phone input changes to reset verification status
 *
 * @package Brandner_Custom
 * @since 2.2.0
 */
(function($) {
    'use strict';

    var config = window.brandnerPhoneVerification || {};
    var cooldownTimer = null;
    var cooldownSeconds = 0;
    var lastVerifiedPhone = config.verifiedPhone || '';

    // Zustellstatus: alle 4 s nachfragen, bis zugestellt/gescheitert (Server meldet "haengt" nach 120 s)
    var DELIVERY_POLL_INTERVAL = 4000;
    var DELIVERY_POLL_MAX = 40;
    var deliveryPollTimer = null;
    var deliveryPolls = 0;
    var lastSentPhone = '';

    var countryPrefixes = config.countryPrefixes || {};

    // =========================================================================
    // Initialization
    // =========================================================================

    function init() {
        var $phoneInput = $('#billing_phone');
        if (!$phoneInput.length) {
            return;
        }

        injectUI($phoneInput);
        bindEvents();
        populateFromStored();

        // Set initial state
        if (config.isVerified) {
            setVerifiedState();
            lastVerifiedPhone = getNormalizedPhone();
        }
    }

    /**
     * Inject the verification button next to the phone input wrapper.
     * Handles two layouts:
     *   1) Profile-completion page: prefix dropdown wrapper exists
     *   2) Edit-account page: plain billing_phone input (fallback)
     */
    function injectUI($phoneInput) {
        // Only inject SMS verification button if the feature is enabled
        if (!config.smsEnabled) {
            return;
        }

        var $wrapper = $('#brandner-phone-input-wrapper');
        if ($wrapper.length) {
            // Profile-completion layout: flag-select + input + button
            $wrapper.wrap('<div class="brandner-phone-verify-wrapper"></div>');
            $wrapper.after(
                '<button type="button" class="brandner-phone-verify-btn" id="brandner-send-sms-btn">' +
                config.i18n.sendCode +
                '</button>'
            );
        } else {
            // Fallback (edit-account): wrap the plain tel input + button
            $phoneInput.wrap('<div class="brandner-phone-verify-wrapper"></div>');
            $phoneInput.after(
                '<button type="button" class="brandner-phone-verify-btn" id="brandner-send-sms-btn">' +
                config.i18n.sendCode +
                '</button>'
            );
        }
    }

    /**
     * Populate the display input from the stored billing_phone (E.164) value.
     * Splits into country prefix (→ flag select) and national part (→ input).
     */
    function populateFromStored() {
        var stored = $('#billing_phone').val();
        if (!stored) return;

        var cleaned = stored.replace(/[\s\-\(\)\/]/g, '');
        if (cleaned.charAt(0) !== '+') {
            // National number without prefix — show as-is
            $('#brandner_phone_display').val(cleaned);
            return;
        }

        // Find the longest matching country prefix
        var bestPrefix = '';
        var bestCC = '';
        for (var cc in countryPrefixes) {
            var prefix = countryPrefixes[cc];
            if (cleaned.indexOf(prefix) === 0 && prefix.length > bestPrefix.length) {
                bestPrefix = prefix;
                bestCC = cc;
            }
        }

        if (bestCC) {
            $('#brandner_phone_prefix').val(bestCC);
            // Extract national part (strip the prefix)
            var national = cleaned.substring(bestPrefix.length);
            // Add leading 0 for display if not present (German convention)
            if (national && national.charAt(0) !== '0') {
                national = '0' + national;
            }
            $('#brandner_phone_display').val(national);
        } else {
            // Unknown prefix — show full number
            $('#brandner_phone_display').val(cleaned);
        }
    }

    // =========================================================================
    // Prefix / Country Sync
    // =========================================================================

    /**
     * Sync the flag select from the billing_country select.
     * Does NOT touch the number input — the user's typed number stays.
     */
    function syncPrefixFromCountry() {
        var country = $('#billing_country').val() || 'DE';
        if (countryPrefixes[country]) {
            $('#brandner_phone_prefix').val(country);
            updateHiddenPhone();
        }
    }

    /**
     * Handle flag select change → sync billing_country + update hidden field.
     * The number input shows the national part and is NOT affected.
     */
    function handleFlagChange() {
        var newCC = $('#brandner_phone_prefix').val();
        updateHiddenPhone();

        // Also sync billing_country if it has this option
        var $billingCountry = $('#billing_country');
        if ($billingCountry.length && $billingCountry.find('option[value="' + newCC + '"]').length) {
            $billingCountry.val(newCC);
        }
    }

    /**
     * Build E.164 from input → hidden billing_phone.
     *
     * Two modes:
     *  1) User typed international number (+49175…) → detect prefix, update flag, store as-is
     *  2) User typed national number (0175…) → combine with flag-select prefix
     */
    function updateHiddenPhone() {
        var raw = $('#brandner_phone_display').val().trim();

        if (!raw) {
            $('#billing_phone').val('');
            return;
        }

        var cleaned = raw.replace(/[\s\-\(\)\/]/g, '');

        // International: user typed a + prefix directly
        if (cleaned.charAt(0) === '+' && cleaned.length > 1) {
            // Only digits after +? Otherwise treat as incomplete
            var digits = cleaned.substring(1);
            if (!/\d/.test(digits)) {
                $('#billing_phone').val('');
                return;
            }

            // Detect country from typed prefix and update flag
            // Prefer DACH + US for shared prefixes (e.g. +1 → US not CA)
            var preferred = ['DE', 'AT', 'CH', 'US', 'GB'];
            var bestPrefix = '';
            var bestCC = '';
            for (var cc in countryPrefixes) {
                var p = countryPrefixes[cc];
                if (cleaned.indexOf(p) === 0) {
                    if (p.length > bestPrefix.length) {
                        bestPrefix = p;
                        bestCC = cc;
                    } else if (p.length === bestPrefix.length && preferred.indexOf(cc) !== -1) {
                        bestPrefix = p;
                        bestCC = cc;
                    }
                }
            }
            if (bestCC) {
                var $flag = $('#brandner_phone_prefix');
                if ($flag.val() !== bestCC) {
                    $flag.val(bestCC);
                    // Sync billing_country
                    var $bc = $('#billing_country');
                    if ($bc.length && $bc.find('option[value="' + bestCC + '"]').length) {
                        $bc.val(bestCC);
                    }
                }
            }
            // Store cleaned E.164 directly
            $('#billing_phone').val(cleaned);
            return;
        }

        // National: combine flag-select prefix + number (only digits, strip leading zeros)
        var cc2 = $('#brandner_phone_prefix').val() || 'DE';
        var prefix = countryPrefixes[cc2] || '+49';
        var cleanNational = cleaned.replace(/\D/g, '').replace(/^0+/, '');

        if (cleanNational) {
            $('#billing_phone').val(prefix + cleanNational);
        } else {
            $('#billing_phone').val('');
        }
    }

    // =========================================================================
    // Event Binding
    // =========================================================================

    function bindEvents() {
        // Send code button
        $(document).on('click', '#brandner-send-sms-btn', handleSendCode);

        // Display phone input — update hidden field + change detection
        $('#brandner_phone_display').on('input change', function() {
            updateHiddenPhone();
            handlePhoneChange();
        });

        // Flag select change — swap prefix in display input
        $('#brandner_phone_prefix').on('change', function() {
            handleFlagChange();
            handlePhoneChange();
        });

        // Billing country change — sync flag select + prefix
        $('#billing_country').on('change', function() {
            syncPrefixFromCountry();
        });

        // OTP digit inputs
        $(document).on('input', '.brandner-otp-digit', handleOtpInput);
        $(document).on('keydown', '.brandner-otp-digit', handleOtpKeydown);
        $(document).on('paste', '.brandner-otp-digit', handleOtpPaste);
        $(document).on('focus', '.brandner-otp-digit', function() {
            $(this).select();
        });

        // Verify button
        $(document).on('click', '#brandner-sms-verify-btn', handleVerify);

        // Resend button
        $(document).on('click', '#brandner-sms-resend-btn', handleResend);

        // Modal close
        $(document).on('click', '#brandner-sms-modal-close', closeModal);
        $(document).on('click', '#brandner-sms-modal', function(e) {
            if ($(e.target).is('#brandner-sms-modal')) {
                closeModal();
            }
        });
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $('#brandner-sms-modal').is(':visible')) {
                closeModal();
            }
        });
    }

    // =========================================================================
    // Phone Change Detection
    // =========================================================================

    function handlePhoneChange() {
        // If phone changed from verified number, reset verification
        if (config.isVerified) {
            var currentPhone = $('#billing_phone').val().replace(/[\s\-\(\)\/]/g, '');
            // Simple check: if input changed significantly, reset
            if (currentPhone !== lastVerifiedPhone) {
                resetVerificationState();
            }
            return;
        }

        // Nummer nach dem Versand korrigiert (Tippfehler): sofort neu anfordern lassen,
        // die Sperre von 60 s gilt nur fuer dieselbe Nummer
        if (lastSentPhone && getNormalizedPhone() !== lastSentPhone) {
            lastSentPhone = '';
            stopDeliveryPolling();
            if (cooldownTimer) {
                clearInterval(cooldownTimer);
                cooldownTimer = null;
            }
            $('#brandner-send-sms-btn').prop('disabled', false).text(config.i18n.sendCode);
            $('#brandner-phone-status').html('');
        }
    }

    function getNormalizedPhone() {
        return $('#billing_phone').val().replace(/[\s\-\(\)\/]/g, '');
    }

    // =========================================================================
    // Send Code
    // =========================================================================

    function handleSendCode() {
        var phone = $('#billing_phone').val();
        if (!phone || phone.trim().length < 6) {
            showInlineError(config.i18n.phoneRequired);
            $('#brandner_phone_display').focus();
            return;
        }

        var $btn = $('#brandner-send-sms-btn');
        $btn.prop('disabled', true).text(config.i18n.sending);

        var country = $('#brandner_phone_prefix').val() || $('#billing_country').val() || 'DE';

        $.ajax({
            type: 'POST',
            url: config.ajaxUrl,
            data: {
                action: 'brandner_send_sms_code',
                nonce: config.nonce,
                phone: phone,
                country: country
            },
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    openModal();
                    startCooldown(60);
                    $btn.text(config.i18n.resend);
                    lastSentPhone = getNormalizedPhone();
                    startDeliveryPolling();
                } else {
                    showInlineError(
                        response.data?.message || config.i18n.smsError,
                        response.data?.outage === true
                    );
                    $btn.prop('disabled', false).text(config.i18n.sendCode);
                }
            },
            error: function() {
                showInlineError(config.i18n.smsError);
                $btn.prop('disabled', false).text(config.i18n.sendCode);
            }
        });
    }

    // =========================================================================
    // Verify Code
    // =========================================================================

    function handleVerify() {
        var code = getOtpValue();
        if (code.length !== 6) {
            showModalError('Bitte geben Sie alle 6 Ziffern ein.');
            return;
        }

        var $btn = $('#brandner-sms-verify-btn');
        $btn.prop('disabled', true).text(config.i18n.verifying);
        hideModalError();

        $.ajax({
            type: 'POST',
            url: config.ajaxUrl,
            data: {
                action: 'brandner_verify_sms_code',
                nonce: config.nonce,
                code: code
            },
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    config.isVerified = true;
                    lastVerifiedPhone = getNormalizedPhone();
                    setVerifiedState();
                    closeModal();
                } else {
                    $btn.prop('disabled', false).text(config.i18n.verify);
                    showModalError(response.data?.message || config.i18n.wrongCode);
                    if (response.data?.expired) {
                        clearOtpInputs();
                    }
                }
            },
            error: function() {
                $btn.prop('disabled', false).text(config.i18n.verify);
                showModalError(config.i18n.smsError);
            }
        });
    }

    // =========================================================================
    // Resend
    // =========================================================================

    function handleResend() {
        var $btn = $('#brandner-sms-resend-btn');
        $btn.prop('disabled', true);
        clearOtpInputs();
        hideModalError();

        var phone = $('#billing_phone').val();
        var country = $('#brandner_phone_prefix').val() || $('#billing_country').val() || 'DE';

        $.ajax({
            type: 'POST',
            url: config.ajaxUrl,
            data: {
                action: 'brandner_send_sms_code',
                nonce: config.nonce,
                phone: phone,
                country: country
            },
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    startCooldown(60);
                    $('#brandner-sms-modal-info').text(response.data.message);
                    lastSentPhone = getNormalizedPhone();
                    startDeliveryPolling();
                } else {
                    showModalError(response.data?.message || config.i18n.smsError);
                    $btn.prop('disabled', false);
                }
            },
            error: function() {
                showModalError(config.i18n.smsError);
                $btn.prop('disabled', false);
            }
        });
    }

    // =========================================================================
    // Delivery Status Polling
    // =========================================================================

    function startDeliveryPolling() {
        stopDeliveryPolling();
        deliveryPolls = 0;
        deliveryPollTimer = setTimeout(pollDelivery, DELIVERY_POLL_INTERVAL);
    }

    function stopDeliveryPolling() {
        if (deliveryPollTimer) {
            clearTimeout(deliveryPollTimer);
            deliveryPollTimer = null;
        }
    }

    function scheduleNextPoll() {
        deliveryPolls++;
        if (deliveryPolls < DELIVERY_POLL_MAX) {
            deliveryPollTimer = setTimeout(pollDelivery, DELIVERY_POLL_INTERVAL);
        } else {
            deliveryPollTimer = null;
        }
    }

    function pollDelivery() {
        deliveryPollTimer = null;

        $.ajax({
            type: 'POST',
            url: config.ajaxUrl,
            data: {
                action: 'brandner_sms_delivery_status',
                nonce: config.nonce
            },
            dataType: 'json',
            success: function(response) {
                var data = (response && response.success && response.data) || {};

                if (data.state === 'delivered') {
                    hideModalError();
                    $('#brandner-phone-status').html('');
                    if (data.message) {
                        $('#brandner-sms-modal-info').text(data.message);
                    }
                    return;
                }

                if (data.state === 'failed') {
                    showDeliveryHint(data.message);
                    return;
                }

                if (data.state === 'pending') {
                    if (data.message) {
                        showDeliveryHint(data.message);
                    }
                    scheduleNextPoll();
                }
                // unknown: keine Pruefung moeglich -> still beenden
            },
            error: scheduleNextPoll
        });
    }

    /**
     * Hinweis im offenen Fenster und dauerhaft unter dem Telefonfeld — falls der
     * Kunde das Fenster schliesst, um die Nummer zu korrigieren.
     */
    function showDeliveryHint(message) {
        if (!message) {
            return;
        }
        showModalError(message);
        showInlineError(message, true);
    }

    // =========================================================================
    // OTP Input Handling
    // =========================================================================

    function handleOtpInput() {
        var $this = $(this);
        var val = $this.val();

        // Only allow digits
        if (val && !/^\d$/.test(val)) {
            $this.val('');
            return;
        }

        // Auto-advance to next input
        if (val && val.length === 1) {
            var index = parseInt($this.data('index'));
            if (index < 5) {
                $('.brandner-otp-digit[data-index="' + (index + 1) + '"]').focus();
            }
        }

        // Auto-verify when all 6 digits entered
        if (getOtpValue().length === 6) {
            handleVerify();
        }
    }

    function handleOtpKeydown(e) {
        var $this = $(this);
        var index = parseInt($this.data('index'));

        // Backspace: clear current and go back
        if (e.key === 'Backspace' && !$this.val() && index > 0) {
            $('.brandner-otp-digit[data-index="' + (index - 1) + '"]').val('').focus();
            e.preventDefault();
        }

        // Left arrow
        if (e.key === 'ArrowLeft' && index > 0) {
            $('.brandner-otp-digit[data-index="' + (index - 1) + '"]').focus();
            e.preventDefault();
        }

        // Right arrow
        if (e.key === 'ArrowRight' && index < 5) {
            $('.brandner-otp-digit[data-index="' + (index + 1) + '"]').focus();
            e.preventDefault();
        }
    }

    function handleOtpPaste(e) {
        e.preventDefault();
        var pasteData = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
        var digits = pasteData.replace(/\D/g, '').substring(0, 6);

        if (digits.length > 0) {
            for (var i = 0; i < digits.length && i < 6; i++) {
                $('.brandner-otp-digit[data-index="' + i + '"]').val(digits[i]);
            }
            // Focus last filled or next empty
            var focusIndex = Math.min(digits.length, 5);
            $('.brandner-otp-digit[data-index="' + focusIndex + '"]').focus();

            // Auto-verify if all 6 entered
            if (digits.length === 6) {
                handleVerify();
            }
        }
    }

    function getOtpValue() {
        var code = '';
        $('.brandner-otp-digit').each(function() {
            code += $(this).val() || '';
        });
        return code;
    }

    function clearOtpInputs() {
        $('.brandner-otp-digit').val('');
        $('.brandner-otp-digit[data-index="0"]').focus();
    }

    // =========================================================================
    // Modal
    // =========================================================================

    function openModal() {
        clearOtpInputs();
        hideModalError();
        $('#brandner-sms-modal-info').text(config.i18n.enterCode);
        $('#brandner-sms-verify-btn').prop('disabled', false).text(config.i18n.verify);
        $('#brandner-sms-modal').fadeIn(200);
        $('body').css('overflow', 'hidden');

        // Focus first input after animation
        setTimeout(function() {
            $('.brandner-otp-digit[data-index="0"]').focus();
        }, 250);
    }

    function closeModal() {
        $('#brandner-sms-modal').fadeOut(200);
        $('body').css('overflow', '');
    }

    // =========================================================================
    // Cooldown Timer
    // =========================================================================

    function startCooldown(seconds) {
        cooldownSeconds = seconds;
        var $sendBtn = $('#brandner-send-sms-btn');
        var $resendBtn = $('#brandner-sms-resend-btn');

        $sendBtn.prop('disabled', true);
        $resendBtn.prop('disabled', true);

        updateCooldownDisplay();

        if (cooldownTimer) {
            clearInterval(cooldownTimer);
        }

        cooldownTimer = setInterval(function() {
            cooldownSeconds--;
            if (cooldownSeconds <= 0) {
                clearInterval(cooldownTimer);
                cooldownTimer = null;
                $sendBtn.prop('disabled', false).text(config.i18n.resend);
                $resendBtn.prop('disabled', false).text(config.i18n.resend);
            } else {
                updateCooldownDisplay();
            }
        }, 1000);
    }

    function updateCooldownDisplay() {
        var text = config.i18n.cooldown.replace('%d', cooldownSeconds);
        $('#brandner-send-sms-btn').text(text);
        $('#brandner-sms-resend-btn').text(text);
    }

    // =========================================================================
    // State Management
    // =========================================================================

    function setVerifiedState() {
        // Stop cooldown timer
        if (cooldownTimer) {
            clearInterval(cooldownTimer);
            cooldownTimer = null;
        }
        stopDeliveryPolling();
        lastSentPhone = '';

        var $status = $('#brandner-phone-status');
        $status.html(
            '<span class="brandner-phone-verified">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> ' +
            config.i18n.verified +
            '</span>'
        );
        $('#brandner_phone_verified').val('1');
        $('#brandner-send-sms-btn').prop('disabled', true).text(config.i18n.verified).addClass('is-verified');
    }

    function resetVerificationState() {
        config.isVerified = false;
        var $status = $('#brandner-phone-status');
        $status.html('');
        $('#brandner_phone_verified').val('0');
        $('#brandner-send-sms-btn')
            .prop('disabled', false)
            .text(config.i18n.sendCode)
            .removeClass('is-verified');

        // Clear any running cooldown
        if (cooldownTimer) {
            clearInterval(cooldownTimer);
            cooldownTimer = null;
        }
    }

    // =========================================================================
    // UI Helpers
    // =========================================================================

    function showInlineError(message, persist) {
        var $status = $('#brandner-phone-status');
        $status.html('<span class="brandner-phone-error">' + message + '</span>');

        // Stoerungs-Hinweise stehen lassen — der Text erklaert, wie es weitergeht
        if (persist) {
            return;
        }

        setTimeout(function() {
            if ($status.find('.brandner-phone-error').length) {
                $status.html('');
            }
        }, 5000);
    }

    function showModalError(message) {
        $('#brandner-sms-modal-error').text(message).show();
    }

    function hideModalError() {
        $('#brandner-sms-modal-error').hide().text('');
    }

    // =========================================================================
    // Init
    // =========================================================================

    $(document).ready(init);

})(jQuery);
